import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import administratorType from '../common/types/administratorType'
import AdminAutocomplete from './AdminAutocomplete'

const NewAdminsList = ({ selectedAdmins, onAdminSelect, onAdminRemove, allAdmins }) => {
  return (
    <Fragment>
      {
        selectedAdmins.map(admin => {
          return (
            <AdminAutocomplete
              key={admin.rid}
              onAdminSelect={onAdminSelect}
              onAdminRemove={onAdminRemove}
              admins={allAdmins}
              defaultValue={admin.name}
              defaultItem={admin}
              selectedAdmins={selectedAdmins}
            />
          )
        })
      }
      <AdminAutocomplete
        onAdminSelect={onAdminSelect}
        admins={allAdmins}
        selectedAdmins={selectedAdmins}
        newAdmin
      />
    </Fragment>
  )
}

NewAdminsList.propTypes = {
  allAdmins:      PropTypes.arrayOf(administratorType),
  onAdminRemove:  PropTypes.func.isRequired,
  onAdminSelect:  PropTypes.func.isRequired,
  selectedAdmins: PropTypes.arrayOf(administratorType)
}

export default NewAdminsList
